import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { useConfig } from "../context/ConfigContext";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger,
} from "./ui/dialog";

/**
 * Schedule Consultation button.
 * - Renders ONLY when a valid CALENDLY_URL is configured on the backend.
 * - Opens Calendly in a responsive modal (iframe loads lazily on open).
 */
export function CalendlyButton({ variant = "solid", testid = "calendly-button", label = "Schedule Consultation" }) {
  const { calendlyUrl } = useConfig();
  const [open, setOpen] = useState(false);

  if (!calendlyUrl) return null;

  const base =
    "inline-flex items-center justify-center gap-2 rounded-sm px-7 py-3.5 text-sm font-600 tracking-wide transition-colors duration-300";
  const styles =
    variant === "solid"
      ? "bg-gold text-navy hover:bg-gold-soft"
      : "border border-navy/25 text-navy hover:border-gold hover:text-navy";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" className={`${base} ${styles}`} data-testid={testid}>
          <CalendarClock className="h-4 w-4" strokeWidth={1.6} />
          {label}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl overflow-hidden rounded-sm border-navy/10 p-0" data-testid="calendly-modal">
        <DialogHeader className="border-b border-navy/10 px-6 py-4">
          <DialogTitle className="font-serif text-2xl font-500 text-navy">Schedule a Consultation</DialogTitle>
        </DialogHeader>
        {open && (
          <iframe
            title="Calendly scheduling"
            src={calendlyUrl}
            className="h-[70vh] w-full border-0"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
